// proposal-change-types.ts
//
// Kiểu wire-nội-bộ của một `proposed_change` và hằng bootstrap kind, tách
// riêng để proposal-applier.ts và các file guard của nó cùng import mà không
// tạo vòng import (guard cần kiểu + hằng; applier cần guard).

import type { Ticket } from "./schemas/ticket-schema.js";

export interface ProposedChange {
  op: "create" | "amend" | "cancel" | "supersede";
  ticket_id?: string;
  expected_revision?: number;
  patch?: Partial<Ticket>;
  new_ticket?: Ticket;
}

/**
 * Audit F1: the kinds `feature-dispatch-gate-guard.ts` lets dispatch BEFORE
 * G0/G1 (they produce the artifacts those gates approve). Kept as a literal
 * here rather than imported from the guard so this pure transaction module
 * stays free of a dependency on the dispatch layer. Re-exported by
 * proposal-applier.ts ONLY so
 * `test/lib/autopilot/bootstrap-kinds-pinned-across-layers.test.ts` can pin it
 * equal to the guard's `BOOTSTRAP_TICKET_KINDS` — drift between the two is red.
 */
export const BOOTSTRAP_KINDS: readonly string[] = ["survey", "plan"];
